export default __webpack_public_path__ + "static/expressive-engine-262c27a4c1113dba2930ca130f6140e7.mp4";